/** Dependencies */
import { useEffect, useState } from 'react';

/** Components */
import FilterString from './../../Filters/FilterString';

/** Helpers */
import { 
  deepEqual, 
  isNullOrUndefined, 
  getUrlPart 
} from './../../../helpers/functions';

/** SCSS */
import './FiltersWindowWidgets.scss';

function Url( props )
{
  const {
    id,
    pictoTitle,
    filterLabel,
    autoCompletedValues,
    removeDomain,
    initFilterValues,
    callBackFunction
  } = props;

  /** Init State */
  const [ filterValues, setFilterValues ] = useState( null );

  /** Update Range filter values */
  useEffect( () => 
  {
    // callback function if filter values not null
    if(
      filterValues !== null 
      && typeof callBackFunction === 'function' 
      && !deepEqual( filterValues, initFilterValues )
    )
      callBackFunction( filterValues );

  }, [ filterValues ] )

  return(
    <div className='filter-container url'>

      {/* Title */}
      <h4 className='picto-title'>
        { pictoTitle }
        { filterLabel }
      </h4>

      {/* Filter type */}
      <FilterString
        id={ id + '-string' }
        filterLabel={ filterLabel }
        inputLabel={ filterLabel }
        autoCompletedValues={ 
          !isNullOrUndefined( removeDomain ) ? 
            autoCompletedValues.map( url => getUrlPart( url, 'pathname' ) ) 
            : autoCompletedValues 
          }
        initCurrentValues={ initFilterValues !== null ? initFilterValues.value : null }
        callBackFunction={ values => setFilterValues( { ...filterValues, value: values } ) }
      />

    </div>
  )
}

export default Url;